/** Inline AudioWorklet source — loaded via Blob URL (CRA-compatible). */
export const PCM_WORKLET_SOURCE = `
class PCMWorkletProcessor extends AudioWorkletProcessor {
  constructor() {
    super();
    this._chunks = [];
    this._chunkSamples = 0;
    this._flushAtSamples = Math.round(sampleRate * 0.02);
  }
  process(inputs) {
    const input = inputs[0];
    if (input && input.length > 0) {
      const channelData = input[0];
      if (channelData && channelData.length > 0) {
        this._chunks.push(channelData.slice());
        this._chunkSamples += channelData.length;
        if (this._chunkSamples >= this._flushAtSamples) this._flush();
      }
    }
    return true;
  }
  _flush() {
    const merged = new Float32Array(this._chunkSamples);
    let offset = 0;
    for (const chunk of this._chunks) { merged.set(chunk, offset); offset += chunk.length; }
    this._chunks = [];
    this._chunkSamples = 0;
    const pcm16 = new Int16Array(merged.length);
    for (let i = 0; i < merged.length; i++) {
      const sample = Math.max(-1, Math.min(1, merged[i]));
      pcm16[i] = sample < 0 ? sample * 0x8000 : sample * 0x7fff;
    }
    this.port.postMessage(pcm16.buffer, [pcm16.buffer]);
  }
}
registerProcessor("pcm-worklet-processor", PCMWorkletProcessor);
`;
